import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Redirect component for /scan (QR code poster scans)
export const ScanRedirect = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to /network with UTM parameters for QR poster tracking
    navigate('/network?utm_source=whatsapp&utm_medium=qr_poster&utm_campaign=dehradun_student_talent_network&utm_content=poster_v1', { replace: true });
  }, [navigate]);
  
  return null;
};

// Redirect component for /join (WhatsApp caption link clicks)
export const JoinRedirect = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to /network with UTM parameters for caption link tracking
    navigate('/network?utm_source=whatsapp&utm_medium=message&utm_campaign=dehradun_student_talent_network&utm_content=caption_link', { replace: true });
  }, [navigate]);
  
  return null;
};

export default ScanRedirect;
